<template>
  <nav>
    <ol class="divide-y divide-gray-100 md:flex md:divide-y-0 overflow-x-auto overflow-y-hidden">
      
      <li v-for="(step, index) in steps" :key="index"
          class="progress-step relative md:flex-1 md:flex mr-3 last:mr-0 first:rounded-l last:rounded-r"
          :class="[step.status]"
          @click="stepValueIsMultiple(step) ? null : select(step.selection[0], step, index)">
        <!-- <li
          
          class="progress-step relative md:flex-1 md:flex mr-3 last:mr-0 first:rounded-l last:rounded-r"
          :class="[step.status]"
          @click="stepValueIsMultiple(step) ? null : select(step.selection[0], step, index)"
        > -->
          <Popper
            trigger="clickToToggle"
            :append-to-body="true"
            :options="{
              placement: 'right',
              offset: '[10, 200]'
            }"
            class="inline-block w-full z-10"
            :disabled="!stepValueIsMultiple(step)"
          >
            <a
              slot="reference"
              href="#" 
              class="group flex items-center w-full justify-center h-8 z-10 cursor-pointer"
            >
              <span class="px-3 py-2 flex items-center text-xs whitespace-pre ---font-medium">
                
                <span 
                  class="text-xs ---font-medium whitespace-pre flex"
                >
                  {{ progressText(step) }}
                </span>
              </span>
            </a>

            <ul class="z-50 mt-1 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm select" tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">
              <li v-for="val in step.selection"
                  :key="val.task?val.task:val"
                  class="cursor-pointer select-none relative py-2 pl-3 pr-9 hover:text-white"
                  :class="isLink(val) ? 'text-teal-700 font-bold hover:bg-teal-600' : 'text-indigo-900 hover:bg-indigo-600'"
                  @click="select(val, step)">
                <!-- <li 
                  :key="val.task?val.task:val" 
                  class="text-indigo-900 cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-indigo-600 hover:text-white"
                  @click="select(val, step)"
                > -->
                  <!-- 詳細タスク -->
                  <div v-if="val.task" class="flex">
                    <Icon v-if="val.isDone" iconName="CheckCircle" iconType="solid" class="w-5 h-5 mr-1" />
                    <div v-else class="ml-6"></div>
                    <div class="text-xs truncate">
                      {{ val.task }}
                    </div>
                    <div class="text-xs">{{ getDoneDate(val) }}</div>
                  </div>
                  <!-- 詳細タスク以外 -->
                  <span v-else class="font-normal block truncate">
                    {{ val }}
                  </span>
                </li>
              <!-- </li> -->
            </ul>      
          </Popper>
        <!-- </li> -->
      </li>
    </ol>
  </nav>
</template>
<script>
import Popper from 'vue-popperjs'
import 'vue-popperjs/dist/vue-popper.css'
import * as moment from 'moment'
import Icon from '@components/Icon.vue'

export default {
  components: {
    Popper,
    Icon
  },

  props: {
    steps: {
      type: Array,
      default: () => []
    },
    showCheckMarkForCompletedStep: {
      type: Boolean,
      default: false
    },
    // 別の画面へ移る項目の名前（完了・未完了と見分けがつくよう色を変える）
    linkItems: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    progressText() {
      return (step) => {
        let date = ''
        // 完了サブタスクは完了日を表示
        if (step.data.status == 'done' && step.data.doneDate) {
          date = moment(step.data.doneDate).format('M/D') + ' '
        } else {
          date = moment(step.data.limitDate + ' 00:00:00').format('M/D') + ' '
        }
        return date + (step.displayText || step.value || '')
      }
    },

    stepValueIsMultiple() {
      return (step) => {
        return step.selection.length > 1
      }
    },
  },

  methods: {
    select(value, step) {
      this.$emit('change', value, step)
    },

    /**
     * 別の画面へ移る項目か（詳細タスクは対象外）
     * @param val 選択肢
     */
    isLink(val) {
      return typeof val === 'string' && this.linkItems.includes(val)
    },

    /**
     * 詳細タスク 完了日表示
     * @param detail 詳細タスク
     */
    getDoneDate(detail) {
      if (detail.isDone && detail.doneDate) {
        return '　' + moment(detail.doneDate).format('M/D')
      }
      return ''
    }
  }
}
</script>

<style scoped>
li.progress-step {
  @apply bg-gray-300 text-gray-800;
}

/* li.progress-step.current, li.progress-step.current:before, li.progress-step.current:after {
  background-color: rgb(3, 45, 96);
  @apply text-white;
} */

li.progress-step.done, li.progress-step.done:before, li.progress-step.done:after {
  background-color: rgb(76, 155, 220);
  @apply text-white;
}

li.progress-step.open, li.progress-step.open:before, li.progress-step.open:after {
  background-color: rgb(40, 139, 63);
  @apply text-white;
}

li.progress-step.limitOut, li.progress-step.limitOut:before, li.progress-step.limitOut:after {
  background-color: rgb(222, 84, 89);
  @apply text-white;
}

li.progress-step.limitToday, li.progress-step.limitToday:before, li.progress-step.limitToday:after {
  background-color: rgb(238, 164, 27);
  @apply text-white;
}

li.progress-step:hover, li.progress-step:hover:before, li.progress-step:hover:after {
  @apply bg-gray-400;
}

/* li.progress-step.current:hover, li.progress-step.current:hover:before, li.progress-step.current:hover:after {
  background-color: rgb(3, 45, 96);
} */

li.progress-step.done:hover, li.progress-step.done:hover:before, li.progress-step.done:hover:after {
  background-color: rgb(50, 111, 160);
}

li.progress-step.open:hover, li.progress-step.open:hover:before, li.progress-step.open:hover:after {
  background-color: rgb(35, 102, 51);
}

li.progress-step.limitOut:hover, li.progress-step.limitOut:hover:before, li.progress-step.limitOut:hover:after {
  background-color: rgb(222, 63, 68);
}

li.progress-step.limitToday:hover, li.progress-step.limitToday:hover:before, li.progress-step.limitToday:hover:after {
  background-color: rgb(213, 155, 30);
}

li.progress-step:before {
  top: 0;
  height: calc((2rem / 2) + 0.0625rem);
  transform: skew(28deg) translate3d(0, 0, 0);
  box-sizing: border-box;
  @apply bg-gray-300;
}

li.progress-step:first-child:before, li.progress-step:first-child:after {
  left: 1.125rem;
}

li.progress-step:last-child:before, li.progress-step:last-child:after {
  right: .625rem;
}

li.progress-step:after {
  bottom: 0;
  height: 1rem;
  transform: skew(-30deg) translate3d(0, 0, 0);  
  box-sizing: border-box;
  @apply bg-gray-300;
}

li.progress-step:before, li.progress-step:after {
  content: '';
  position: absolute;
  left: -.25rem;
  right: -.3125rem;
  cursor: pointer;  
}

.select {
  top: 23px !important;
}

.text-xss {
  font-size: 11px
}
</style>